// extracted by mini-css-extract-plugin
export default {"title":"PlayList_title__JyxGe","list":"PlayList_list__78hgN","card":"PlayList_card__q6UZV"};